'use strict';

exports.__esModule = true;
exports.transformMarkers = exports.transformResults = exports.nextAvailable = exports.transformAvailabilities = exports.getAllTreatmentIds = undefined;

var _parseFloat = require('babel-runtime/core-js/number/parse-float');

var _parseFloat2 = _interopRequireDefault(_parseFloat);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _helpers = require('../../../../src/client/utils/helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MAX_DECIMAL = 2;
var CALENDAR_SIZE = 3;
var MORNING_LIMIT = 12;
var AFTERNOON_LIMIT = 18;
var CALENDAR_DATE_FORMAT = 'ddd DD/MM';

var specialtyMapping = function specialtyMapping(specialties, specialtyId) {
	for (var _iterator = specialties, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3.default)(_iterator);;) {
		var _ref;

		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}

		var specialty = _ref;

		if (specialty.id === specialtyId) {
			return specialty;
		}
	}
	return null;
};
var timeOfTheDay = function timeOfTheDay(timestampRange) {
	var hours = new _moment2.default.utc(JSON.parse(timestampRange.availability_details.timestamp_range)[0]).get('hour');
	return hours < MORNING_LIMIT && 'morning' || hours < AFTERNOON_LIMIT && 'afternoon' || 'evening';
};
var getAllTreatmentIds = exports.getAllTreatmentIds = function getAllTreatmentIds() {
	var treatmentGroups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	return treatmentGroups.filter(function (treatmentGroup) {
		return treatmentGroup.treatments;
	}).reduce(function (treatments, treatmentGroup) {
		return [].concat(treatments, treatmentGroup.treatments.map(function (_ref2) {
			var id = _ref2.id;
			return id;
		}));
	}, []).join(',');
};

var transformAvailabilities = exports.transformAvailabilities = function transformAvailabilities(availabilities, selectedDate) {
	if (!selectedDate || !availabilities || !availabilities.length) {
		return null;
	}
	return new Array(CALENDAR_SIZE).fill(0).map(function (uselessValue, index) {
		return new _moment2.default.utc(selectedDate).add(index, 'days');
	}).map(function (date) {
		var matchingAvailabilities = availabilities.filter(function (availability) {
			return date.isSame(_moment2.default.utc(availability.start_date), 'day');
		});
		return matchingAvailabilities && matchingAvailabilities.length ? {
			date: date.isSame(new _moment2.default.utc(), 'day') && 'today' || date.isSame(new _moment2.default.utc().add(1, 'day'), 'day') && 'tomorrow' || date.format(CALENDAR_DATE_FORMAT),
			availableMorning: matchingAvailabilities[0].availabilities.filter(function (timeRange) {
				return timeOfTheDay(timeRange) === 'morning';
			}).length,
			availableAfternoon: matchingAvailabilities[0].availabilities.filter(function (timeRange) {
				return timeOfTheDay(timeRange) === 'afternoon';
			}).length,
			availableEvening: matchingAvailabilities[0].availabilities.filter(function (timeRange) {
				return timeOfTheDay(timeRange) === 'evening';
			}).length
		} : {
			date: date.isSame(new _moment2.default.utc(), 'day') && 'today' || date.isSame(new _moment2.default.utc().add(1, 'day'), 'day') && 'tomorrow' || date.format(CALENDAR_DATE_FORMAT)
		};
	});
};

var nextAvailable = exports.nextAvailable = function nextAvailable(availabilities, selectedDate) {
	if (!selectedDate || !availabilities || !availabilities.length) {
		return null;
	}

	var endDate = (0, _moment2.default)(selectedDate).startOf('day').add(CALENDAR_SIZE, 'days');

	var availableWithinCalendarSize = availabilities.reduce(function (acc, item) {
		return (0, _moment2.default)(item.start_date).isBefore(endDate) ? true : acc;
	}, false);

	if (!availableWithinCalendarSize) {
		return (0, _moment2.default)(availabilities[0].start_date);
	}
};

var transformResults = exports.transformResults = function transformResults() {
	var results = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	var specialties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	var startDate = arguments[2];
	var searchedKeyword = arguments[3];
	var searchedNetwork = arguments[4];

	return results.map(function (result) {
		var specialtyId = result.related_specialties && result.related_specialties.length && result.related_specialties.filter(function (sp) {
			return sp.parent_name === 'abstract_top_level_keyword';
		})[0] && result.related_specialties.filter(function (sp) {
			return sp.parent_name === 'abstract_top_level_keyword';
		})[0].id;
		var specialistNetwork = searchedNetwork && result.networks && result.networks.find(function (item) {
			return item === searchedNetwork;
		});
		return {
			priceFrom: result.price_range && result.price_range.length > 1 ? result.price_range[0].length && result.price_range[0] : null,
			availableFrom: result.availabilities && result.availabilities.length ? new _moment2.default.utc(result.availabilities[0].start_date) : null,
			availabilityLoaded: result.availabilityLoaded,
			bookingType: searchedKeyword ? searchedKeyword.name : null,
			profileImage: result.profile_image ? result.profile_image + '_lg.jpg' : '',
			profileName: '' + (results.prefix ? result.prefix + ' ' : '') + result.name,
			averageRating: result.showReviews && result.average_review && !isNaN(Number(result.average_review)) && Number(result.average_review),
			hasBookings: result.has_booking,
			hasRequestAppointment: true,
			profileType: result.type,
			specialtyIcon: specialtyMapping(specialties, specialtyId) && specialtyMapping(specialties, specialtyId).icon_uri,
			peerRecommendations: result.number_of_peer_recommendations,
			profileUrl: result.type + '/' + result.uri_id,
			ApiProfileUrl: result.type + 's/' + result.uri_id,
			id: result.id,
			distance: result.distance && !isNaN(Number(result.distance)) && (0, _parseFloat2.default)(result.distance).toFixed(MAX_DECIMAL),
			subspecialties: result.related_specialties ? result.related_specialties.filter(function (specialty) {
				return specialty.parent_name !== 'abstract_top_level_keyword';
			}).map(function (specialty) {
				return specialty.name;
			}) : [],
			specialty: result.related_specialties ? result.related_specialties.filter(function (specialty) {
				return specialty.parent_name === 'abstract_top_level_keyword';
			}).map(function (specialty) {
				return specialty.name;
			})[0] : null,
			isCore: result.isCore,
			isAHG: result.isAhg,
			isBmi: result.isBmi,
			isRamsay: result.isRamsay,
			isNuffield: result.isNuffield,
			isSpire: result.isSpire,
			relatedPracticeName: result && result.address && result.address.practice_name || '',
			videoConsultation: (0, _helpers.isVideoConsultationAvailable)(result),
			searchedNetwork: specialistNetwork,
			networks: result.networks
		};
	});
};

var transformMarkers = exports.transformMarkers = function transformMarkers(results) {
	return results.filter(function (result) {
		return result.address && result.address.geolocation;
	}).map(function (result, index) {
		return {
			key: index,
			practice_id: result.id,
			position: {
				lng: result.address && result.address.geolocation && JSON.parse(result.address.geolocation).coordinates[0],
				lat: result.address && result.address.geolocation && JSON.parse(result.address.geolocation).coordinates[1]
			},
			infoContent: _react2.default.createElement(
				'a',
				{ href: result.type + '/' + result.uri_id },
				' ',
				result.name,
				' '
			),
			type: result.type
		};
	});
};


// WEBPACK FOOTER //
// ./components/search-page/lib/transformers/search-results.js